export { DetailsModule } from './details.module';
export { ShipmentDetailsService } from './shipment-details.service';

export { ShipmentDetailsComponent } from './details.component';

export * from './tracker-line';
